import { useContext } from 'react';
import { CRMSearchContext } from './context';
export function useCRMSearch() {
  var _state$context$data$t, _state$context$data;
  const context = useContext(CRMSearchContext);
  if (!context) {
    throw new Error('useCRMSearch must be used within a CRMSearchProvider');
  }
  const {
    state,
    send
  } = context;
  return {
    data: state.context.data,
    total: (_state$context$data$t = (_state$context$data = state.context.data) === null || _state$context$data === void 0 ? void 0 : _state$context$data.total) !== null && _state$context$data$t !== void 0 ? _state$context$data$t : 0,
    error: state.context.error,
    isLoading: state.hasTag('loading'),
    isError: state.hasTag('error'),
    retry: () => send({
      type: 'RETRY'
    }),
    search: query => send({
      type: 'SEARCH',
      query
    })
  };
}